import { ChatMessage } from "../types/chat";
import { ReplyMetadata } from "../types/sendMessage";

/**
 * Reply state interface
 */
export interface ReplyState {
  messageId: string;
  senderName: string;
  content: string;
  message: ChatMessage;
}

/**
 * Build reply metadata for sending
 */
export const buildReplyMetadata = (replyState: ReplyState): ReplyMetadata => {
  const metadata = replyState.message.metadata as any;

  // Get thumbnailUrl from original message if available
  const thumbnailUrl = metadata?.thumbnailUrl || metadata?.attachmentUrl || "";

  return {
    type: "text",
    hasReply: "true",
    replyMessageId: replyState.messageId,
    replySenderName: replyState.senderName,
    replyMessage: replyState.content,
    replyThumbnailUrl: thumbnailUrl,
  };
};
